import { reduxKey } from './constants';
export var SYSTEM_MESSAGE_USER_NAME = 'devart';
export var ChatServiceStatus;
(function (ChatServiceStatus) {
    ChatServiceStatus["ONLINE"] = "online";
    ChatServiceStatus["OFFLINE"] = "offline";
    ChatServiceStatus["STARTUP"] = "startup";
})(ChatServiceStatus || (ChatServiceStatus = {}));
export var ChatPageType;
(function (ChatPageType) {
    ChatPageType["OVERLAY"] = "overlay";
    ChatPageType["FULLPAGE"] = "fullpage";
})(ChatPageType || (ChatPageType = {}));
export var ChatParticipantDisplayDataTypes;
(function (ChatParticipantDisplayDataTypes) {
    ChatParticipantDisplayDataTypes["ROOM"] = "room";
    ChatParticipantDisplayDataTypes["USER"] = "user";
    ChatParticipantDisplayDataTypes["MULTI"] = "multichat";
})(ChatParticipantDisplayDataTypes || (ChatParticipantDisplayDataTypes = {}));
export var ChatLabels;
(function (ChatLabels) {
    ChatLabels["ACTIVE"] = "42bfc914-8ae3-4525-8b49-32236b824b19";
    ChatLabels["REQUESTS"] = "7eeeb607-2a32-46e1-b71d-480e4c0b8c3c";
    ChatLabels["DEVIATION"] = "f84b38ba-a32c-4dc6-bc76-4a7585fa7995";
    ChatLabels["GROUP"] = "af06db63-fafc-4c86-86f5-1f49a7e9610c";
})(ChatLabels || (ChatLabels = {}));
export var ChatroomScrollEvent;
(function (ChatroomScrollEvent) {
    /** Used when a user receives a new message */
    ChatroomScrollEvent["NEW_MESSAGE"] = "new_message";
    /** Used when a user sends a message */
    ChatroomScrollEvent["SEND_MESSAGE"] = "send_message";
    /** Used when another user in the room is typing */
    ChatroomScrollEvent["TYPING_INDICATOR"] = "typing_indicator";
    /** Used when the chatroom initially opens */
    ChatroomScrollEvent["INITIAL_OPEN"] = "initial_open";
    /** Used when the chatroom gets minimized and opened back up */
    ChatroomScrollEvent["WINDOW_TOGGLE"] = "window_toggle";
    /** Used when we want to navigate back to the default chat view and restore the user's scroll position */
    ChatroomScrollEvent["RESTORE_SCROLL_POSITION"] = "RESTORE_SCROLL_POSITION";
    /** Used when we display the media bar on the footer */
    ChatroomScrollEvent["MEDIA_BAR"] = "media_bar";
    /** Used when we load more messages */
    ChatroomScrollEvent["LOAD_MORE"] = "load_more";
    /* TODO: Figure out what this one is for. I can't find any usages of it */
    ChatroomScrollEvent["EDITOR_FOCUS"] = "editor_focus";
})(ChatroomScrollEvent || (ChatroomScrollEvent = {}));
export var NewChatRequestStatus;
(function (NewChatRequestStatus) {
    NewChatRequestStatus["PRESUBMIT"] = "presubmit";
    NewChatRequestStatus["INITIALIZING"] = "initializing";
    NewChatRequestStatus["CREATING"] = "creating";
    NewChatRequestStatus["ERROR"] = "error";
})(NewChatRequestStatus || (NewChatRequestStatus = {}));
/**
 * We use this to determine where to pull new chat participants from for a new chat request
 */
export var NewChatRequestSource;
(function (NewChatRequestSource) {
    /**
     * When requesting a chat with a single user given context from surrounding web page elements.
     * e.g.
     * - an "Open Chat" button on a user's profile
     * - an "Open Chat" button on a notification from a user
     */
    NewChatRequestSource["CREATE_OR_OPEN_DM"] = "create_or_open_dm";
    /**
     * When converting a single-user chat to a multi-user chat.
     */
    NewChatRequestSource["CREATE_GROUP_CHAT"] = "create_group_chat";
    /**
     * When creating a new chat from scratch with the new chat window
     */
    NewChatRequestSource["NEW_CHAT_WINDOW"] = "new_chat_window";
})(NewChatRequestSource || (NewChatRequestSource = {}));
export var ChatListSubscriptionStatus;
(function (ChatListSubscriptionStatus) {
    ChatListSubscriptionStatus["LOADING"] = "loading";
    ChatListSubscriptionStatus["LISTENING"] = "listening";
    ChatListSubscriptionStatus["ERROR"] = "error";
    ChatListSubscriptionStatus["NONE"] = "none";
})(ChatListSubscriptionStatus || (ChatListSubscriptionStatus = {}));
export var ChatWorkerStatus;
(function (ChatWorkerStatus) {
    ChatWorkerStatus["ALIVE"] = "alive";
    ChatWorkerStatus["TERMINATED"] = "terminated";
})(ChatWorkerStatus || (ChatWorkerStatus = {}));
export var ChatWorkerIdleStatus;
(function (ChatWorkerIdleStatus) {
    ChatWorkerIdleStatus["BUSY"] = "busy";
    ChatWorkerIdleStatus["IDLE"] = "idle";
    ChatWorkerIdleStatus["WAKING"] = "waking";
})(ChatWorkerIdleStatus || (ChatWorkerIdleStatus = {}));
export var ChatServiceError;
(function (ChatServiceError) {
    ChatServiceError["BROWSER"] = "unsuppored-browser";
    ChatServiceError["LOGOUT"] = "logged-out";
    ChatServiceError["AUTH"] = "auth-failed";
    ChatServiceError["NETWORK"] = "network-disconnectd";
    ChatServiceError["UNKNOWN"] = "unknown";
})(ChatServiceError || (ChatServiceError = {}));
//# sourceMappingURL=types.js.map